import { Countly } from 'modules/countly';
import { datadogRum } from 'modules/datadog';
import { useEffect, useMemo, useState } from 'react';
import { CountlyRemoteConfigPayload, RemoteConfig } from 'types';

const useRemoteConfig = (): RemoteConfig => {
    const [remoteConfigValues, setRemoteConfigValues] = useState<CountlyRemoteConfigPayload | undefined>(undefined);

    useEffect(() => {
        Countly.fetchRemoteConfig()
            .then((remoteConfigs) => setRemoteConfigValues(remoteConfigs))
            .catch((error) => {
                datadogRum.addError(error ?? 'Failed to load countly remote config');
            });
    }, []);

    return useMemo<RemoteConfig>(
        () => ({
            nextAvailableDateRange: remoteConfigValues?.feature_public_scheduler_next_available_date_range ?? 30,
            nextAvailableDateRangeSecondary:
                remoteConfigValues?.feature_public_scheduler_next_available_date_range_secondary ?? 30,
            prnVisibleDateRange: remoteConfigValues?.feature_public_scheduler_prn_visible_date_range ?? 30,
            displayAllAvailableAlternativeProvidersOnLoad:
                remoteConfigValues?.alternative_providers_display_all_providers_on_load ?? false,
            dotPhysicalAgreementEmailEnabled:
                remoteConfigValues?.feature_authenticated_citymd_dot_physical_agreement_email ?? false,
        }),
        [remoteConfigValues]
    );
};

export { useRemoteConfig };
